import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconForYou: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconForYou"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM7 15.5H17V17H7V15.5ZM7 7V10H10V7H7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconForYou;
